'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SuccessOutlined = require('./lib/icons/SuccessOutlined');
  
  
  var _default = _SuccessOutlined;
  exports.default = _default;
  module.exports = _default;